// extracted by mini-css-extract-plugin
export default {"RestorePage":"style_RestorePage__o76+C"};